import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useEffect, useState } from 'react';
import breakpointTokens from '@lmig/lmds-tokens/dist/json/core/breakpoint.json';

/** Properties defined in the breakpoint tokens */

/**
 * Breakpoint to get the current breakpoint based on the window.innerWidth
 * @todo Move into hooks package when that is created
 * @returns current breakpoint ('base', 'sm', 'md', 'lg', 'xl')
 */
export function useCurrentBreakpoint() {
  var _useState = useState(function () {
      return typeof window !== 'undefined' && window.innerWidth;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  /** Keys for all breakpoints vals */
  var breakpointKeys = Object.keys(breakpointTokens.lmig.breakpoint);

  /** Array of all min, max, and raw values */
  var breakpoints = breakpointKeys.map(function (key) {
    return breakpointTokens.lmig.breakpoint[key];
  });

  /** Set the window width in the state */
  var setWindowSize = function setWindowSize() {
    return setWidth(window.innerWidth);
  };

  /** Function to map to breakpoint name before returning */
  var mapWidthToBreakpoint = function mapWidthToBreakpoint(windowWidth) {
    var matchIndex = breakpoints.findIndex(function (val) {
      var low = typeof (val === null || val === void 0 ? void 0 : val.min) === 'string' ? Number(val.min.replace('px', '')) : val.min;
      var high = val !== null && val !== void 0 && val.max ? Number(val.max.replace('px', '')) : Infinity;
      return windowWidth >= low && windowWidth <= high;
    });
    return breakpointKeys[matchIndex];
  };
  useEffect(function () {
    /** Listen for the resize of the window to update the current bp */
    window.addEventListener('resize', setWindowSize);
    return function () {
      return window.removeEventListener('resize', setWindowSize);
    };
  }, []);
  return mapWidthToBreakpoint(width);
}